/**
 * Generates a resized avatar URL with specified height and width if the URL is
 * from `picture2`.
 *
 * This function appends height and width parameters to the provided URL,
 * resizing the avatar image to the desired square dimensions.
 *
 * @param {string} url - The base URL of the avatar image.
 * Should not already contain query parameters for `height` or `width`.
 * @param {number} size - The desired size (in pixels) for both the height and width of the avatar image.
 *
 * @returns {string} The modified URL containing the height and width query parameters.
 */
export const getAvatarResizedURL = (url: string, size: number) =>
  url.includes('picture2') ? `${url}&height=${size}&width=${size}` : url;
